/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import { handleApiError } from "@utils/errorHandler";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import copyIcon from "@icons/ic-copy.svg";
import GeneralData from "./components/GeneralData/GeneralData";
import PollutionParams from "./components/PollutionParams/PollutionParams";
import ContactData from "./components/ContactData/ContactData";
import { loadSingleCenterProduct } from "../CenterProductsList/CenterProductsList.actionCreators";
import Tabs from "./components/Tabs/Tabs";
import PriceList from "../../CenterProductPrice/PriceList/PriceList";
import "react-tooltip/dist/react-tooltip.css";
import activateIcon from "@icons/ic-activate.svg";
import { addDepartment } from "@shared/shared.slice";
import { setSingleCenterProductNotFound } from "../CenterProductsList/CenterProductsList.slice";
import CopyCenterProduct from "../CenterProductsList/components/CopyCenterProduct/CopyCenterProduct";
import Header from "../../Company/CompanyView/components/Header/Header";
import {
  CenterProductViewContainer,
  FlexRow,
  SectionContainer,
  GridRow,
  BreadCrumb,
  ActionButtonDiv,
  ProductTitle,
  ButtonWrapper,
  ButtonData,
  CategoryDetail,
} from "./CenterProductView.styled";
import "./CenterProductView.scss";
import UserInfo from "@utils/UserInfo";
import NotFound from "@components/Errors/NotFound";

/**
 * CenterProductView List,
 * Path - /centre/product/view/{id}
 * @see See [CenterProduct Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2922053641/Centre+product+view+page)
 * @component
 */
const CenterProductView = (props) => {
  const { t } = props;
  const params = useParams();
  const location = useLocation();
  const isCenterProductViewPath = location.pathname.match(
    /^\/company\/view\/(\d+)\/center\/(\d+)\/product\/view\/(\d+)$/
  );
  const [centerProductData, setCenterProductData] = useState([]);
  const dispatch = useDispatch();
  const [countryId, setCountryId] = useState(UserInfo.countryId());
  const [activeTab, setActiveTab] = useState("general");
  const [isCopyVisible, setCopyVisible] = useState(false);
  const [pollutionTab, setPollutionTab] = useState(false);
  const [pollutionParam, setPollutionParam] = useState([]);

  const generalParams = useGetGeneralParameters();
  const { departmentList } = generalParams;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "CONTACT_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "CONTACT_CONFIRMATION_BOX_DELETE_CONTENT"
  );

  const companyId = parseInt(params.id, 10);
  const [companyData, setCompanyData] = useState([]);
  const companyInfo = useSelector((state) => state.companyList.byId[companyId]);

  const selectedCompanyData = useSelector(
    (state) => state.companyList.selectedCompany
  );

  const isSingleCenterProductNotFound = useSelector(
    (state) => state.centerProductsList.isSingleCenterProductNotFound
  );

  useEffect(() => {
    if (
      companyInfo !== undefined &&
      parseInt(companyId, 10) === parseInt(companyInfo.id, 10)
    ) {
      setCompanyData(companyInfo);
      if (companyInfo.platformCountryId) {
        setCountryId(companyInfo.platformCountryId);
      }
    }
    if (
      selectedCompanyData !== null &&
      parseInt(companyId, 10) === parseInt(selectedCompanyData.id, 10)
    ) {
      setCompanyData(selectedCompanyData);
      if (selectedCompanyData.platformCountryId) {
        setCountryId(selectedCompanyData.platformCountryId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo, selectedCompanyData]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  const history = useNavigate();

  // Get IDs from URL params
  // Route /company/view/:id/product/view/:productId - id is companyId, productId is centerProductId
  // Route /centre/product/view/:id - id is centerProductId
  const centerProductId = parseInt(params.productId, 10) || null;
  const companyIdFromUrl = parseInt(params.id, 10) || null;
  const centerId = parseInt(params.centerId, 10) || null;

  const centerProductInfo = useSelector(
    (state) => state.centerProductsList.byId[centerProductId]
  );

  const selectedCenterProductData = useSelector(
    (state) => state.centerProductsList.selectedCenterProduct
  );

  const fetchCenterProductInfo = () => {
    const companyId = companyIdFromUrl;
    if (!companyId || !centerId) return;

    dispatch(
      loadSingleCenterProduct({
        centerProductId,
        companyId,
        centerId,
      })
    );
  };

  const getPollutionParams = () => {
    // Get values from centerProductData (loaded from API) instead of window
    const subCategoryId = centerProductData?.subCategory?.id;
    const productId = centerProductData?.product?.id;
    if (!subCategoryId || !productId) return;

    axios
      .get(
        `/general/pollutionParameters?countryId=${countryId}&subCategoryId=${subCategoryId}&productId=${productId}`
      )
      .then((response) => {
        setPollutionParam(response.data.pollutionParameters);
        if (response.data.pollutionParameters.length > 0) {
          setPollutionTab(true);
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          setPollutionTab(false);
          console.error(
            "Error: an error occurred while fetching pollution params",
            error
          );
        }
      });
  };

  // get general parameters
  const fetchCountryDepartment = () => {
    axios
      .get(`/general/countryDepartments?countryId=${countryId}`)
      .then((response) => {
        dispatch(addDepartment(response.data));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (!departmentList || departmentList?.length === 0) {
      fetchCountryDepartment();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (centerProductData?.subCategory?.id && centerProductData?.product?.id) {
      getPollutionParams();
    }
  }, [centerProductData?.subCategory?.id, centerProductData?.product?.id]);

  useEffect(() => {
    // Only fetch if we don't have data and have the required IDs
    dispatch(setSingleCenterProductNotFound(false));
    const hasData =
      (centerProductInfo &&
        parseInt(centerProductInfo.id, 10) === parseInt(centerProductId, 10)) ||
      (selectedCenterProductData &&
        parseInt(selectedCenterProductData.id, 10) ===
          parseInt(centerProductId, 10));
    if (!hasData && companyIdFromUrl && centerId) {
      fetchCenterProductInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centerProductId, centerId, companyIdFromUrl]);

  useEffect(() => {
    if (
      centerProductInfo !== undefined &&
      parseInt(centerProductId, 10) === parseInt(centerProductInfo.id, 10)
    ) {
      setCenterProductData(centerProductInfo);
    }
    if (
      selectedCenterProductData !== null &&
      parseInt(centerProductId, 10) ===
        parseInt(selectedCenterProductData.id, 10)
    ) {
      setCenterProductData(selectedCenterProductData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centerProductInfo, selectedCenterProductData]);

  const onEdit = () => {
    history(
      `/company/view/${companyIdFromUrl}/center/${centerId}/product/edit/${centerProductData.id}`
    );
  };

  const handleCenterProductStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("CENTER_PRODUCT_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent(
        "CENTER_PRODUCT_CONFIRMATION_BOX_ENABLE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("CENTER_PRODUCT_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "CENTER_PRODUCT_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/companies/${companyIdFromUrl}/centres/${centerId}/products/${centerProductData.id}/updateStatus`,
          centerProductData.isActive === 1 ? `0` : 1
        )
        .then((response) => {
          setActionConfirmStatus(false);
          setCenterProductData(response?.data[0]);
        })
        .catch((error) => {
          setActionConfirmStatus(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const copyCenterProduct = () => {
    setCopyVisible(true);
  };

  const onClose = () => {
    setCopyVisible(false);
  };

  const onCompanyInfoClick = (id) => {
    history(`/company/view/${id}/general-info`);
  };

  if (!isCenterProductViewPath || isSingleCenterProductNotFound) {
    return <NotFound />;
  }

  return (
    <CenterProductViewContainer>
      <Header
        companyData={companyData}
        onCompanyInfoClick={onCompanyInfoClick}
      />
      {centerProductData?.id && (
        <>
          <FlexRow>
            <SectionContainer>
              <GridRow column="1fr 1fr" marginBottom="15px">
                <BreadCrumb>
                  <Link
                    to={`/company/view/${companyId}/products`}
                    className="center-products-view__link"
                  >
                    {"<"}
                    {t("GENERAL_BACK_TO_LIST")}
                  </Link>
                </BreadCrumb>
                {!!centerProductData.product.isActive && (
                  <ActionButtonDiv>
                    <Image
                      src={editIcon}
                      alt={t("PRODUCT_ACTION_TOOLTIP_EDIT")}
                      title={t("PRODUCT_ACTION_TOOLTIP_EDIT")}
                      classname="center-products-list__image-icon-margin"
                      styles={{ width: "25px", marginRight: "3px" }}
                      onClick={onEdit}
                    />
                    <Image
                      src={copyIcon}
                      alt={t("PRODUCT_ACTION_TOOLTIP_COPY")}
                      title={t("PRODUCT_ACTION_TOOLTIP_COPY")}
                      classname="center-products-list__image-icon-margin"
                      styles={{ width: "25px", marginRight: "3px" }}
                      onClick={copyCenterProduct}
                    />
                    {centerProductData.isActive === 1 && (
                      <Image
                        src={deleteIcon}
                        alt={t("PRODUCT_ACTION_TOOLTIP_DISABLE")}
                        title={t("PRODUCT_ACTION_TOOLTIP_DISABLE")}
                        classname="center-products-list__image-icon-margin"
                        styles={{ width: "25px" }}
                        onClick={() => handleCenterProductStatus(0)}
                      />
                    )}
                    {centerProductData.isActive !== 1 && (
                      <Image
                        src={activateIcon}
                        alt={t("PRODUCT_ACTION_TOOLTIP_ACTIVATE")}
                        title={t("PRODUCT_ACTION_TOOLTIP_ACTIVATE")}
                        classname="center-products-list__image-icon-margin"
                        onClick={() => handleCenterProductStatus(1)}
                        styles={{ width: "25px" }}
                      />
                    )}
                  </ActionButtonDiv>
                )}
              </GridRow>
              <GridRow column="1fr 1fr">
                <ProductTitle>
                  # {centerProductData.id}
                  {centerProductData?.product?.name
                    ? " - " + centerProductData.product.name
                    : ""}
                  {centerProductData.label
                    ? " - " + centerProductData.label
                    : " "}
                </ProductTitle>
                <ButtonWrapper>
                  <ButtonData
                    color={
                      centerProductData.isActive === 1 ? "#32A728" : "#E83F1E"
                    }
                  >
                    {centerProductData.isActive === 1
                      ? t("ACTIVE")
                      : t("INACTIVE")}
                  </ButtonData>
                </ButtonWrapper>
              </GridRow>
              <GridRow column="1fr" marginTop="-20px">
                <CategoryDetail>
                  {t(centerProductData?.product?.category.name) +
                    "-" +
                    t(centerProductData?.product?.subCategory.name)}
                </CategoryDetail>
              </GridRow>
              <GridRow column="1fr">
                <div>
                  <ButtonData
                    marginRight="10px"
                    color={
                      centerProductData.serviceType === "IN"
                        ? "#32A728"
                        : "#0A4986"
                    }
                  >
                    {centerProductData.serviceType === "IN"
                      ? t("PRODUCTS_FILTER_REMOVAL")
                      : t("PRODUCTS_FILTER_SUPPLY")}
                  </ButtonData>

                  {centerProductData.logisticFlow === 1 && (
                    <ButtonData color="#EFCA06" marginRight="10px">
                      {t("CENTER_PRODUCT_LOGISTIC_FLOW_ROUND_TRIP")}
                    </ButtonData>
                  )}
                  {centerProductData.logisticFlow === 2 && (
                    <ButtonData color="#6ACFCB" marginRight="10px">
                      {t("LOGISTIC_FLOW_RETURN_LOAD")}
                    </ButtonData>
                  )}
                </div>
              </GridRow>
              <Tabs
                toggleTab={toggleTab}
                activeTab={activeTab}
                pollutionTab={pollutionTab}
                polllutions={centerProductData.pollutionParameters}
              />
              {activeTab === "general" && (
                <GeneralData data={centerProductData} />
              )}
              {activeTab === "contact" && (
                <ContactData
                  id={centerProductData.id}
                  companyId={parseInt(params.id, 10)}
                  countryId={companyData?.platformCountryId}
                />
              )}
              {activeTab === "pollution" && (
                <PollutionParams
                  polllutions={centerProductData.pollutionParameters}
                  pollutionParam={pollutionParam}
                  strictLimit={centerProductData.strictLimit}
                  setCenterProductData={setCenterProductData}
                  companyId={parseInt(params.id, 10)}
                  centerId={centerId}
                  centerProductId={parseInt(params.productId, 10)}
                  countryId={countryId}
                />
              )}
            </SectionContainer>
          </FlexRow>
          <FlexRow>
            <PriceList
              centerProductStatus={centerProductData.isActive}
              subCategoryId={centerProductData.product?.subCategory?.id ?? 0}
              companyId={parseInt(params.id, 10)}
              centerId={centerId}
              centerProductId={parseInt(params.productId, 10)}
              countryId={countryId}
            />
          </FlexRow>
        </>
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {isCopyVisible && (
        <CopyCenterProduct
          data={centerProductData}
          onClose={onClose}
          companyId={parseInt(params.id, 10)}
          centerId={centerId}
        />
      )}
    </CenterProductViewContainer>
  );
};

CenterProductView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CenterProductView);
